const index = "data-index";
export {
  index
};
//# sourceMappingURL=TabsPanelDataAttributes.js.map
